import React, { useRef } from "react";
import { ArrowRight, ArrowLeft } from "@phosphor-icons/react";

// swiper
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import Container from "Components/Container/Container";
const OtherProjects = ({ data }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="normal-section-80  flex flex-col justify-center my-primary">
      <Container>
        <div className="flex items-center justify-center mb-16 gap-x-6">
          <button
            ref={prevRef}
            className="slider-arrow z-[100] rounded-full flex items-center justify-center bg-black text-2xl text-black bg-light p-1"
          >
            <ArrowLeft />
          </button>
          <p className="text-3xl lg:text-4xl bebas text-white text-center tracking-[2px]">
            Other Project of similar category
          </p>
          <button
            ref={nextRef}
            className="slider-arrow z-[100] rounded-full flex items-center justify-center bg-black text-2xl text-black bg-light p-1"
          >
            <ArrowRight />
          </button>
        </div>
      </Container>

      <div className=" relative">
        <Swiper
          className="partnerSwipper"
          spaceBetween={14}
          slidesPerView={1}
          slidesPerGroup={1}
          navigation={{
            clickable: true,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          breakpoints={{
            768: {
              slidesPerView: 2,
              slidesPerGroup: 2,
            },
            992: {
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
          }}
          modules={[Autoplay, Navigation]}
          speed={1000}
        >
          {data?.map(({ title, image, slug }, index) => (
            <SwiperSlide
              key={index}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Link
                to={`/projects/${slug}`}
                className="h-[400px] relatove w-full group"
              >
                <img src={image} alt="" className="w-full h-full " />
                <p className="absolute group-hover:underline left-4 text-3xl font-bold bottom-4 z-[10]  text-white">
                  {title}
                </p>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default OtherProjects;
